import actionTypes from '../actions'

const salesTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  sortBy: 'date',
  desc: true,
  status: [],
}

const salesTransactionTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  paymentMethod: [],
  paymentStatus: [],
  sortBy: 'created_date',
  desc: true,
}

const saleVolumeTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  paymentMethod: [],
  paymentStatus: [],
  sortBy: 'created_date',
  desc: true,
}

const saleDisputeTableDataDefault = {
  records: [],
  pageNo: 1,
  pageSize: 20,
  totalCount: 0,
  paymentStatus: [],
  sortBy: 'total_amount',
  desc: true,
}

const initialState = {
  //Sales data
  loadingSalesData: false, //TODO: Check usability

  loadingSalesTransactionChartData: false,
  loadingSalesSalesVolumeChartData: false,
  loadingSalesVolumeChartData: false,

  loadingSalesTableData: false,
  loadingSalesChartData: false,

  loadingTransactionTableData: false,
  loadingSaleVolumeTableData: false,
  loadingDisputeTableData: false,

  salesTableData: salesTableDataDefault,

  salesTransactionTableData: salesTransactionTableDataDefault,
  saleVolumeTableData: saleVolumeTableDataDefault,
  saleDisputeTableData: saleDisputeTableDataDefault,

  salesTransactionChartData: [],
  salesVolumeChartData: [],
  salesDisputeChartData: [],

  sales: [],

  salesTransactions: [],
  salesVolume: [],
  salesCustomers: [],
  salesDisputes: [],
  salesOverviewDaySpan: 30,
}

const reducer = (state = initialState, action) => {
  if (action.type === actionTypes.SETSALESOVERVIEWDAYSPAN) {
    return {
      ...state,
      salesOverviewDaySpan: action.data,
    }
  }
  if (action.type === actionTypes.SALESDATAFETCHED) {
    return {
      ...state,
      sales: action.data,
    }
  }

  if (action.type === actionTypes.LOADINGSALESCHARTDATA) {
    return { ...state, loadingSalesChartData: action.data }
  }

  if (action.type === actionTypes.SALESTABLEDATAFETCHED) {
    if (!action.data) {
      return state
    }
    return {
      ...state,
      salesTableData: { ...action.data },
    }
  }
  if (action.type === actionTypes.LOADINGSALESDATA) {
    return {
      ...state,
      loadingSalesData: action.data,
    }
  }
  if (action.type === actionTypes.LOADINGSALESTRANSACTIONCHARTDATA) {
    return {
      ...state,
      loadingSalesTransactionChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETSALESTRANSACTIONCHARTDATA) {
    return {
      ...state,
      salesTransactionChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGSALESVOLUMECHARTDATA) {
    return {
      ...state,
      loadingSalesVolumeChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETSALESVOLUMECHARTDATA) {
    return {
      ...state,
      salesVolumeChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGSALESDISPUTECHARTDATA) {
    return {
      ...state,
      loadingSalesDisputeChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETSALESDISPUTECHARTDATA) {
    return {
      ...state,
      salesDisputeChartData: action.data,
    }
  }
  if (action.type === actionTypes.SETLOADINGSALESTABLEDATA) {
    return {
      ...state,
      loadingSalesTableData: action.data,
    }
  }

  if (action.type === actionTypes.LOADINGTRANSACTIONTABLEDATA) {
    return {
      ...state,
      loadingTransactionTableData: action.data,
    }
  }

  if (action.type === actionTypes.SALESTRANSACTIONTABLEDATAFETCHED) {
    return {
      ...state,
      salesTransactionTableData: action.data,
    }
  }

  if (action.type === actionTypes.LOADINGSALEVOLUMETABLEDATA) {
    return {
      ...state,
      loadingSaleVolumeTableData: action.data,
    }
  }

  if (action.type === actionTypes.SALESVOLUMETABLEDATAFETCHED) {
    return {
      ...state,
      saleVolumeTableData: action.data,
    }
  }

  if (action.type === actionTypes.LOADINGDISPUTETABLEDATA) {
    return {
      ...state,
      loadingDisputeTableData: action.data,
    }
  }

  if (action.type === actionTypes.SALESDISPUTETABLEDATAFETCHED) {
    return {
      ...state,
      saleDisputeTableData: action.data,
    }
  }
  if (action.type === actionTypes.RESET_SALES_STATE) {
    return { ...initialState }
  }
  return state
}

export default reducer
